export default __webpack_public_path__ + "static/media/ps_10.125cff15.png";